export default class Settings {
  constructor() {
    this.endpoint = null;
    this.apiKey = null;
  }
  setEndpoint(value) {
    this.endpoint = value;
  }
  setApiKey(value) {
    this.apiKey = value;
  }
}
